module.exports = __webpack_public_path__ + "img/status-icn_inactivated@3x.d6a2fc58.png";